import React, { useState } from 'react';
import { UserCogIcon } from 'lucide-react';
import { EmployeeSetting } from '../../types/commission';
import { Card } from '../sf/Card';
import { ExampleDataBadge } from '../sf/ExampleDataBadge';
import { Td, Th } from '../sf/DataTable';
import { NewBadge } from '../sf/NewBadge';
import { Switch } from '../sf/Switch';
interface EmployeeRulesCardProps {
  settings: EmployeeSetting[];
  editable: boolean;
  onToggleBonus: (setting: EmployeeSetting, bonusOn: boolean) => void;
}
export function EmployeeRulesCard({
  settings,
  editable,
  onToggleBonus
}: EmployeeRulesCardProps) {
  const [rows, setRows] = useState(settings);
  function handleToggle(setting: EmployeeSetting, bonusOn: boolean) {
    setRows(prev => prev.map(row => row.id === setting.id ? {
      ...row,
      bonusOn
    } : row));
    onToggleBonus(setting, bonusOn);
  }
  return <Card title="Employee rules" icon={UserCogIcon} iconBg="#5A1BA9" meta="Per-employee overrides: custom flat rules, Team Lead / Director BPS from the employee record, and the per-employee Bonus switch (NEW — not in main today)" bodyClassName="" actions={<ExampleDataBadge data-id="element-84" data-mp="k1pjlqh3bks7" />} data-id="element-83" data-mp="1vh7ug0slffi5">
      <div className="overflow-x-auto" data-id="element-85" data-mp="p0sn36hf9iy2">
        <table className="w-full border-collapse" data-id="element-86" data-mp="ozqzk2j7z3zg">
          <thead data-id="element-87" data-mp="tr92ux8ptgnl">
            <tr data-id="element-88" data-mp="trr1u1mri8z7">
              <Th data-id="element-89" data-mp="tsalbms295fc">Employee</Th>
              <Th data-id="element-90" data-mp="tsk6mx25uoep">Branch</Th>
              <Th data-id="element-91" data-mp="yqc3m5hnx0pr">Base Source</Th>
              <Th data-id="element-92" data-mp="ypajlbio53vw">Custom Rule</Th>
              <Th data-id="element-93" data-mp="yq2bab95ahgw">Team Lead / Director BPS</Th>
              <Th data-id="element-94" data-mp="12re56sz1xouw">
                <span className="inline-flex items-center gap-1.5" data-id="element-95" data-mp="12qvzl5qi1yab">
                  Bonus switch <NewBadge label="NEW" data-id="element-96" data-mp="17qqt7h1nt1z2" />
                </span>
              </Th>
            </tr>
          </thead>
          <tbody data-id="element-97" data-mp="1cp23ttzs3gic">
            {rows.map(row => <tr key={row.id} data-id="element-98" data-mp="39idcsxj81uli">
                <Td className="whitespace-nowrap font-semibold" data-id="element-99" data-mp="39j6p0e0y9cb1">{row.name}</Td>
                <Td className="text-sf-weak" data-id="element-100" data-mp="3eh82mjflwjf4">{row.branch}</Td>
                <Td className="text-sf-weak" data-id="element-101" data-mp="3ehq7g4gc45yn">{row.baseSource}</Td>
                <Td data-id="element-102" data-mp="36htoyhg4bde1">
                  {row.customRule ? <>
                      <span className="block" data-id="element-103" data-mp="32fyrjo1b5k5j">{row.customRule}</span>
                      <span className="font-mono text-xs text-sf-weak" data-id="element-104" data-mp="3geyg6votlz1p">{row.customRuleKey} · flat</span>
                    </> : <span className="text-sf-weak" data-id="element-105" data-mp="3bf3owr14v7g4">—</span>}
                </Td>
                <Td data-id="element-106" data-mp="3pebohl17khku">
                  {row.roleBps ? <span className="flex flex-wrap items-center gap-1.5 whitespace-nowrap" data-id="element-107" data-mp="3leayr48nsjyh">
                      <span className="text-xs text-sf-weak" data-id="element-108" data-mp="30203bxa39k2">{row.roleBps.field}</span>
                      <span className="font-semibold tabular-nums" data-id="element-109" data-mp="31wd842b5xdl">{row.roleBps.value}</span>
                      <span className="text-xs text-sf-weak" data-id="element-110" data-mp="3u8pcv3hgdog0">· read-only · no bonus BPS</span>
                      <ExampleDataBadge data-id="element-111" data-mp="cw56itz5xuct" />
                    </span> : <span className="text-sf-weak" data-id="element-112" data-mp="80zgpk2n3vjg">—</span>}
                </Td>
                <Td data-id="element-113" data-mp="rlq36hxfus6l">
                  {row.roleBps?.field === 'Director BPS' ? <span className="text-xs text-sf-weak" data-id="element-114" data-mp="vm06fmtuj4hr">—</span> : <Switch checked={row.bonusOn} label={`Monthly Bonus for ${row.name}`} disabled={!editable} onChange={next => handleToggle(row, next)} data-id="element-115" data-mp="hlz5669o5v1r" />}
                </Td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </Card>;
}